module.exports = __webpack_public_path__ + "img/style_12_pl.e5ee4b3a.jpeg";